<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Gráficos de Benefícios") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-md-12">
        <div class="col-12">
          <p>
            Período de pesquisa selecionado:
            <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
            <b-link
              href="#"
              @click.prevent="void 0"
              class="mb-2"
              variant="info"
              v-b-popover.hover.top="
                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
              "
            >
              <i class="fas fa-info-circle"></i>
            </b-link>
          </p>
        </div>
        <div class="col-12 no-print" v-if="viewFilterReport">
          <!-- Filtros -->
          <form @submit.prevent="getAnalytics" ref="formFiltros">
            <div class="row">
              <form-calendar
                v-model="data_inicio"
                grid="6"
                label="Data Inicial"
              />

              <form-calendar
                v-model="data_fim"
                grid="6"
                label="Data Final"
                :required="verificaDataInicial"
              />
            </div>
            <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default"
                  @click="
                    limparFiltros();
                    viewFilterReport = false;
                  "
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>

                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Gerar Relatório") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
      ></filter-reports> -->

      <div class="col-12" id="boxPrint">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Concessões Por Período"
            active
            @click.prevent="changeTab('Concessões Por Período')"
          >
            <div class="col-md-12" v-if="tabAtiva == 'Concessões Por Período'">
              <area-graph
                :loading="loading"
                :data="report.lista_concessoes"
                titulo="Concessões"
                tipo="concessoes"
                :range="range"
                sizearea="300px"
                sizecard="375px"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small pb-1 mb-1">
                Total de
                <b v-if="report.total_lista_concessoes"
                  >({{ report.total_lista_concessoes }})
                </b>
                {{ tabAtiva }}
              </p>
            </div>
          </b-tab>
          <b-tab
            title="Benefícios Por Tipo"
            @click.prevent="changeTab('Benefícios Por Tipo')"
          >
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Benefícios Por Tipo'">
                <pie-chart
                  :data="report.tipos_beneficios"
                  height="800px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Benefícios Por Unidades"
            @click.prevent="changeTab('Benefícios Por Unidades')"
          >
            <div class="row">
              <div
                class="col-md-12"
                v-if="tabAtiva == 'Benefícios Por Unidades'"
              >
                <pie-chart
                  :donut="true"
                  :data="report.unidades_beneficios"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center">
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "BenefíciosGraficos",
  data() {
    return {
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      range: "yearly",
      report: {
        lista_concessoes: [],
        total_lista_concessoes: 0,
        percapita: [],
        corraca: [],
        usuarios: [],
        deficiencias: [],
        datas: {
          start: "",
          end: "",
        },
      },
      tabAtiva: "Concessões Por Período",
      filtros: {},
      chartData: [
        ["Jan", 4],
        ["Feb", 2],
        ["Mar", 10],
        ["Apr", 5],
        ["May", 3],
      ],
    };
  },
  mounted() {
    this.getAnalytics();
  },

  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Concessões Por Período";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/beneficios/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            ...tab,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    limparFiltros() {
      this.data_inicio = "";
      this.data_fim = "";
    },
  },
};
</script>

